import default_es_sub_status_messages from '../es/substatusMessages'

export default {
  ...default_es_sub_status_messages,
  subStatusWorkflowExecutionError: 'Fallo en consulta de información, contacta a Rep Service',
}
